export const ANALYTICS_INIT_SCRIPT = () => `

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}

gtag('consent', 'default', {
  ad_personalization: 'denied', // 'granted',
  ad_storage: 'denied', // 'granted',
  ad_user_data: 'denied', // 'granted',
  analytics_storage: 'denied', // 'granted',
  functionality_storage: 'granted', // 'granted',
  personalization_storage: 'granted', // 'granted',
  security_storage: 'granted', // 'granted',
});`;
